export const setCookie = (
    cookieName: string,
    value: string,
    expiresInDays: number,
    path?: string
) => {
    let expires = new Date();
    expires.setDate(expires.getDate() + expiresInDays);
    document.cookie = `${cookieName}=${value}; expires=${expires.toUTCString()}; path=${path ?? '/'}`;
};

export const getCookieValue = (cookieName: string) => {
    const cookies = document.cookie.split(';');
    let cookieValue = '';

    for (const cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name.trim() === cookieName) {
            cookieValue = value;
        }
    }

    return cookieValue;
};
